import { cmsFetcher as sharedCmsFetcher } from '@packages/shared/src/utils/cmsFetcher/cmsFetcher';
import { getStaticBucketUrl, UrlType } from './apiUrl.staticPage';

const getEndpoint = (
  bucketUrl: string,
  pathname: string,
  locale: string,
  menu?: string,
  type?: UrlType,
) =>
  getStaticBucketUrl({
    bucketUrl,
    pathname,
    language: locale.substring(0, 2),
    menu: menu || '',
    type: type || UrlType.PAGE,
  });

/**
 * fetch data from static endpoint like google bucket
 * If fetch is failing an error is thrown
 *
 * @param bucketUrl
 * @param pathname
 * @param locale
 * @param type
 * @returns data from bucket as json
 */
const cmsFetcher = async <T>({
  pathname = '/',
  bucketUrl,
  locale = 'de-DE',
  type = UrlType.PAGE,
}: {
  pathname?: string | string[];
  bucketUrl?: string;
  locale?: string;
  type?: UrlType;
}) => {
  if (bucketUrl) {
    // prepare correct pathName of content-json to request from bucket
    const fileName =
      Array.isArray(pathname) && pathname
        ? pathname
            ?.filter((pathSegment: string) => !/de|fr|storefront/.exec(pathSegment))
            ?.join('-')
        : pathname || '/';
    // Assemble the final url to be fetched
    const apiCmsUrlStaticFileCms = getStaticBucketUrl({
      bucketUrl,
      pathname: fileName,
      language: locale.substring(0, 2),
      type,
      menu: type === UrlType.MENU ? fileName : undefined,
    });

    return sharedCmsFetcher<T>(apiCmsUrlStaticFileCms);
  }
  return null;
};

export { cmsFetcher, getEndpoint };
